<div style="float:left">

    <div class="ws-section__header">
        <h4 class="ws-section__header__title">
            Select A Log File Type
        </h4>
        &nbsp; &nbsp;&nbsp;
        <select
            class="form-select form-select-sm"
            style="width: auto"
            [(ngModel)]="selectedLocation"
            (change)="locationChanged()"
        >
            <option value="" disabled selected>Please Choose...</option>
            @for (option of LogFileLocationList; track option) {
                <option [ngValue]="option"> {{ option.logFileLocationTypeName }}</option>
            }
        </select>
    </div>

    @if (fileList != null && fileList.length > 0) {
        <div>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th>File Name</th>
                    <th>Creation/Last Modified Date</th>
                    <th>Status</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    @for (file of fileList; track file) {
                        <tr>
                            <td>{{ file.logFileName }}</td>
                            <td>{{ file.displayDate }}</td>
                            <td>{{ file.isFileLocked ? " Currently being locked " : "Ready for download"}}</td>
                            <td >
                                <button [disabled]="file.isFileLocked" class="ace-btn btn-primary" (click)="downloadLogFile(file)">Download</button>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }

    @if (fileList != null && fileList.length == 0) {
        <div>
            No Files Returned
        </div>
    }

</div>

